import { createSlice } from "@reduxjs/toolkit";

const initialInterviewSlice = {
  listLoading: false,
  actionLoading: false,
  selectedEvent: null,
  interviewEvents: [],
  userEvents: [],
};

export const interviewManagementSlice = createSlice({
  name: "interviewManagementSlice",
  initialState: initialInterviewSlice,
  reducers: {
    startCall: (state, action) => {
      if (action.payload === "action") {
        state.actionLoading = true;
      } else {
        state.listLoading = true;
      }
    },
    stopCall: (state, action) => {
      if (action.payload === "action") {
        state.actionLoading = false;
      } else {
        state.listLoading = false;
      }
    },
    setEvents: (state, action) => {
      state.interviewEvents = action?.payload?.data?.data?.events;
      state.listLoading = false;
    },
    setSelectedEvent: (state, action) => {
      state.selectedEvent = action?.payload?.event;
    },

    setUserEvents: (state, action) => {
      state.userEvents = action?.payload;
    },
  },
});
